import { ME, setMyHand } from '../../3-store/core/me';
import { peers, type Peer } from '../../3-store/core/peers';
import { linkGroupOf } from './links';
import { isMeeting } from '../../../shared/world/links';
import { amTeacher } from './classroom';

// 화면 공유와 손들기: 둘 다 모임(shared/world/links.ts) 안에서만 뜻이 있다. 서버가 같은 규칙을 지킨다(공유 칸은 모임마다 하나).

// 지금 내 모임에서 공유하는 사람: 나이면 mine, 아니면 그 사람의 접속 id와 이름. 없으면 null
export function currentShare(): { mine: boolean; id: string | null; name: string } | null {
  const g = linkGroupOf(ME);
  if (!isMeeting(g)) return null;   // 화면 공유는 테이블·학교 모임에서만
  if (ME.share) return { mine: true, id: null, name: '' };
  for (const r of peers.values()) if (r.sh && linkGroupOf(r) === g) return { mine: false, id: r.id, name: r.name };
  return null;
}

// 그 사람의 손이 올라와 있고 나와 같은 모임인가: 다른 모임 사람의 손은 보이지 않는다
export const handUp = (r: Peer) => !!r.hd && isMeeting(linkGroupOf(ME)) && linkGroupOf(r) === linkGroupOf(ME);

export function toggleHand() { if (isMeeting(linkGroupOf(ME)) && !amTeacher()) setMyHand(!ME.hand); }   // 강사는 손을 들지 않는다
